var brand_finder_links = document.querySelectorAll('[href="/pages/brand-finder"]');
var cartLinks = document.querySelectorAll('[href="/cart"]');
var shopLinks = document.querySelectorAll('[href="/collections/all"]');

const isUS = Shopify.country == 'US' ? true : false;

const isProductNoUS = document.querySelectorAll('.Not-Available-in-US')?.length > 0 ? true : false;
const NoUSProduct = isProductNoUS == true ? document.getElementsByClassName('Not-Available-in-US') : null;

const isProductStoreFinder = document.getElementsByClassName('Available-on-US-store-finder')?.length > 0 ? true : false;
const storeFinderProduct = isProductStoreFinder == true ? document.getElementsByClassName('Available-on-US-store-finder') : null;


const accordionGroup = isProductNoUS || isProductStoreFinder ? document.getElementsByClassName('accordion') : null;
const accordionSingle = null;

const productItems = isUS ? document.getElementsByClassName('product-item') : [];
const productItemsHidden = isUS ? document.getElementsByClassName('hide-product-us') : [];
const productCardsMini = isUS ? document.getElementsByClassName('product-card-mini') : [];


function deleteProductHTMLFromCarousels(){
    var swiperSlides = document.getElementsByClassName('swiper-slide');
    if(swiperSlides.length == 0){ return; }
    Array.from(swiperSlides).forEach((slide) => {
      if(slide.firstElementChild.classList.contains('hide-product-us')){
         slide.remove();
      }
  })
}

function displayBrandFinder(brand_finder_links){
  if(brand_finder_links.length > 0){
    for(var i=0; i < brand_finder_links.length; i++){
      brand_finder_links[i].setAttribute('style', 'display: flex !important')
    }
  }
}

function hideLinks(links){
  if(links.length > 0){
    for(var i=0; i < links.length; i++){
      links[i].parentNode.setAttribute('style', 'display: none !important')
    }
  }
}

function addHideUSClass(){
  var NoUSProduct = document.getElementsByClassName('Not-Available-in-US')
  if(NoUSProduct.length > 0){
    NoUSProduct[0].classList.add('hide-product-info-us')  
  }
}

function addStoreFinderUSClass(storeFinderProduct){
  storeFinderProduct[0].classList.add('hide-product-info-store-finder-us')
}

function addStoreFinderButtonToProduct(storeFinderProduct){
  const storeFinderProductMeta = storeFinderProduct != null ? document.querySelector('.product__meta') : null;
  if(storeFinderProductMeta != null){
    var newLink = document.createElement('a');
    newLink.href = '/pages/brand-finder';
    newLink.textContent = 'Go to Store Finder';
    newLink.target = '_blank';  // Opens the link in a new tab
    newLink.classList.add('store-finder-product-link')
    
    storeFinderProductMeta.appendChild(newLink);
  }
}

function hideDeliveryAccordion(accordionGroup){
  for (var i=0;i<accordionGroup.length;i++){
    if(accordionGroup[i].getElementsByClassName('accordion__label')[0].innerText.includes('Delivery')){
      accordionGroup[i].setAttribute('style', 'display: none !important;')
    }
  }
}

function assignHiddenPriceClass(productItems){
  for(var i=0;i<productItems.length;i++){
    productItems[i].classList.add('product-hidden-price')
  } 
}

function assignHiddenInUSClass(productItemsHidden){
  for(var i=0;i<productItemsHidden.length;i++){
    productItemsHidden[i].classList.add('product-hidden')
  }
}

if(isUS){
    document.addEventListener("DOMContentLoaded", function() {
      addHideUSClass()
      hideDeliveryAccordion(accordionGroup)
  });
}

if(isProductStoreFinder && isUS ){
  addStoreFinderUSClass(storeFinderProduct)
  hideDeliveryAccordion(accordionGroup)
  addStoreFinderButtonToProduct(storeFinderProduct)
}

if(isUS){
  displayBrandFinder(brand_finder_links)
  hideLinks(cartLinks)
  hideLinks(shopLinks)
  assignHiddenPriceClass(productItems)
  assignHiddenPriceClass(productCardsMini)
  assignHiddenInUSClass(productItemsHidden)

  document.addEventListener("shopify:section:load", function(event) {
    deleteProductHTMLFromCarousels();
  });
  document.addEventListener("DOMContentLoaded", function() {
    deleteProductHTMLFromCarousels();
  });
}






